import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { UsuariosGestoresService } from "../../../services/empresas/usuarios-gestores.service";
import { FormField, FormFieldOption } from "../../../dto/util/form-field";
import { ListasService } from "../../../services/listas.service";
import { TranslateService } from "@ngx-translate/core";
import { FormGroup, Validators } from "@angular/forms";
import {
  AgregarGestorDTO,
  DetalleGestorDTO,
  DetalleUsuarioDTO, FiltroGestorDTO,
  ListaGestorDTO,
  ModificarGestorDTO, RespEliminarGestorDTO
} from "../models/gestorDTO";
import {Constants_empresa} from "../constants/constants_empresa";
import {AlertaModalService} from "../../../services/util/alerta-modal.service";
import {FiltroDto} from "../../../dto/util/filtro-dto";
import {TableComponent} from "../../util/table/table.component";
import {TableColumn} from "../../../dto/util/table-column";
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { Constants } from '../../../constants/constants';
import { ModalDatosObservatorioComponent } from '../modal-datos-observatorio/modal-datos-observatorio.component';

@Component({
  selector: 'app-usuarios-gestores',
  templateUrl: './usuarios-gestores.component.html',
  styleUrl: './usuarios-gestores.component.scss'
})
export class UsuariosGestoresComponent implements OnInit, AfterViewInit {
  @ViewChild(TableComponent) tabla!: TableComponent;
  @ViewChild(ModalDatosObservatorioComponent)
  datosObservatorioComponent!: ModalDatosObservatorioComponent;
  // Listas
  gestores: any[] = [];
  columnasGestores: TableColumn[] = [];
  tiposDocumento: FormFieldOption[] = [];
  gestoresSeleccionados: DetalleGestorDTO[] = [];
  // Tables
  tamanoPagina = 10;
  totalPaginas = 0;
  paginaActual = 1;
  // Multilenguaje
  tableText: any = {};
  comunText: any = {};
  // Boolean
  mostrarFormulario = false;
  sePuedeActualizar = false;
  sePuedeEliminar = false;
  esAgregar = true;
  // Formularios
  camposFormGestores: FormField[] = [];
  formGroupGestores!: FormGroup;
  // DTO
  gestorSeleccionado!: DetalleGestorDTO;
  // Number
  idJuridica = 0;
  idGestor = 0;
  idNatural = 0;
  // Filtros
  filtroGestores: FiltroGestorDTO = {
    filtros : {
      tipoIdentificacion: 0,
      identificacion: '',
      nombre: ''
    },
    ordenarPor: '',
    ordenarAsc: false,
    tamanoPagina: 0,
    selectedPage: 0
  }

  userInfoSession: UserDataDto = {};

  primerInicioSesion: boolean = false;


  constructor(
    private empresaService: UsuariosGestoresService,
    private listaService: ListasService,
    private translate: TranslateService,
    private alertService: AlertaModalService
  ) {
    this.userInfoSession = JSON.parse(sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) || '{}');
    this.primerInicioSesion = this.userInfoSession.primerInicioSesion!;
  }
  ngOnInit(): void {
    // Multilenguaje
    this.translate.stream('gestion-usuarios').forEach(text => {
      for (const key of Object.keys(text)) {
        this.tableText[key] = text[key];
        this.initColumnsGestores();
      }
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
      this.buildForm();
    });
    // Lista gestores registrados
    this.listaGestores();
    // Lista tipos documento
    this.listaTiposDocumento();
  }

  ngAfterViewInit(): void {
    if (this.primerInicioSesion && 
      this.userInfoSession.tipoUsuario?.Tipo_Usuario == Constants.Empresa) {
      this.datosObservatorioComponent.abrirModal();
    }
  }

  // Función que consume el servicio de listar los usuarios gestores asociados a la empresa
  listaGestores(
    pagina?: number,
    limite?: number,
    idTipoIdentificacion?: number,
    identificacion?: string,
    nombre?: string,
    ordenarPor?: string,
    orden?: string
  ){
    this.empresaService.listarGestores(
      pagina,
      limite,
      this.userInfoSession.idPersonaJuridica!,
      idTipoIdentificacion,
      identificacion,
      nombre,
      ordenarPor,
      orden
    ).subscribe((resp: ListaGestorDTO) => {
      if (resp.status === Constants_empresa.STATUS_OK) {
        this.gestores = resp.data.datos;
        this.paginaActual = resp.data.paginacion.paginaActual;
        this.totalPaginas = resp.data.paginacion.totalPaginas;
        this.gestoresSeleccionados = [];
      } else {
        this.alertService.error('', resp.message);
      }
    })
  }
  // Función que consume el servicio de listar los tipos de documento
  listaTiposDocumento(){
    this.listaService.getDocumentTypeList().subscribe(tipos => {
      this.tiposDocumento = tipos.map(tipo => ({
        Id: tipo.Id ?? '',
        Nombre: tipo.Descripcion || '',
      }));
      this.initColumnsGestores();
    });
  }
  // Se habilita el formulario de tipo y número de identificación para agreegar un usuario como gestor
  agregar(){
    this.mostrarFormulario = true;
  }
  // Función que consume el servicio de actualizar el usuario seleccionado
  modificar(){
    this.mostrarFormulario = true;
    this.esAgregar = false;
  }
  // Función que consume el servicio de eliminar los usuarios seleccionados
  eliminar(){
    this.empresaService.eliminarGestores({
      ids: this.gestoresSeleccionados.map(gestor => gestor.id),
      idPersonaJuridica: this.idJuridica
    }).subscribe((resp: RespEliminarGestorDTO) => {
      if (resp.status === Constants_empresa.STATUS_OK) {
        this.alertService.exito(resp.message);
        this.sePuedeActualizar = false;
        this.sePuedeEliminar = false;
        this.gestoresSeleccionados = [];
        this.tabla.clearSelection();
        this.listaGestores();
      } else {
        this.alertService.error(resp.message);
      }
    });
  }
  // Se inicializan las columnas de la tabla
  initColumnsGestores(){
    this.columnasGestores = [
      {
        id: 'tipoIdentificacion',
        field: 'tipoIdentificacion',
        title: this.tableText['tipo-identificacion'],
        type: 'select',
        elements: this.tiposDocumento,
        option: 'Nombre',
        value: 'Id',
        filterable: true,
        sortable: true,
      },
      {
        id: 'identificacion',
        field: 'identificacion',
        title: this.tableText['numero-identificacion'],
        type: 'text',
        filterable: true,
        sortable: true,
      },
      {
        id: 'nombres',
        field: 'nombre',
        title: this.tableText['nombre'],
        type: 'text',
        filterable: true,
        sortable: true,
      },
    ]
  }

  // Se inicializa el formulario de tipo y número de documento
  buildForm(){
    this.camposFormGestores = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-documento'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        personTypeId: '1',
        errorMessages: { required: this.comunText['tipo-documento-required'] },
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-documento'],
        type: 'text',
        required: true,
        placeholder: this.comunText['numero-documento-placeholder'],
        width: '6',
        visible: true,
        validation: [Validators.minLength(4)],
        errorMessages: {
          required: this.comunText['numero-documento-required'],
          minlength: this.comunText['numero-documento-minlength'],
        },
      },
    ]
  }
  // Función que consume el servicio que verifica si el usuario está registrado en Justifácil y es persona natural
  onSubmit(form: FormGroup){
    this.formGroupGestores = form;
    const tipoIdentificacion = this.formGroupGestores?.get('typeOfDocument')?.value;
    const numeroIdentificacion = this.formGroupGestores?.get('numberOfDocument')?.value;
    const tipoIdentificacionStr = this.tiposDocumento.find((tipo: FormFieldOption) => tipo.Id == tipoIdentificacion)?.Nombre;
    this.verificar(tipoIdentificacion, numeroIdentificacion, tipoIdentificacionStr);
  }
  verificar(tipoIdentificacion: number, numeroIdentificacion: string, tipoIdentificacionStr?: string){
    this.empresaService.verificarUsuario(tipoIdentificacion, numeroIdentificacion).subscribe((resp: DetalleUsuarioDTO) => {
      if (resp.status === Constants_empresa.STATUS_NOT_FOUND) {
        this.alertService.advertencia(
          this.tableText['usuario-no-encontrado'],
          tipoIdentificacionStr + ' ' + numeroIdentificacion
        );
      } else if (resp.status === Constants_empresa.STATUS_OK) {
        if (resp.data.esPersonaNatural && resp.data.existeEnJustiFacil){
          this.idNatural = resp.data.datosUsuario.idPersonaNatural;
          // Si el usuario se encuentra registrado se muestra una alerta, preguntando si se desea agregar como gestor
          this.alertService.confirmacion(
            tipoIdentificacionStr + ' ' + numeroIdentificacion,
            this.tableText['agregar-gestor'],
            () => {
              if (this.esAgregar) {
                this.agregarGestor(resp.data.datosUsuario.idPersonaNatural, resp.data.datosUsuario.idUsuario);
              } else {
                this.actualizarGestor(resp.data.datosUsuario.idPersonaNatural);
              }
            },
            () => {}
          );
        }
      } else {
        this.alertService.error('', resp.message);
      }
    });
  }
  // Función que consume el servicio de asociar el usuario encontrado como gestor
  agregarGestor(idNatural: number, idUsuario: number) {
    // Por el momento el ID jurídica es el mismo, mientras consolidamos la HU que maneja el login del perfil empresa
    this.empresaService.agregarGestor({
      idPersonaJuridica: this.userInfoSession.idPersonaJuridica!,
      idPersonaNatural: idNatural,
      idUsuario: idUsuario
    }).subscribe({
      // Se maneja con next y error, debido que el error 409 se puede capturar en error: y no en next:
      next: (resp: AgregarGestorDTO) => {
        if (resp.status === Constants_empresa.STATUS_CREATED) {
          this.alertService.exito(resp.message);
          this.mostrarFormulario = false;
          this.sePuedeActualizar = false;
          this.sePuedeEliminar = true;
          this.gestoresSeleccionados = [];
          this.listaGestores();
        }
      },
      error: (err) => {
        if (err.status === Constants_empresa.STATUS_CONFLICT) {
          this.alertService.error(err.error?.message);
        }
      }
    });
  }
  // Función que consume el servicio de actualizar el gestor seleccionado
  actualizarGestor(idNatural: number) {
    this.empresaService.actualizarGestor({
      id: this.idGestor,
      idPersonaJuridica: this.idJuridica,
      nuevoIdPersonaNatural: idNatural
    }).subscribe({
      // Se maneja con next y error, debido que el error 409 se puede capturar en error: y no en next:
      next: (resp: ModificarGestorDTO) => {
        if (resp.status === Constants_empresa.STATUS_OK) {
          this.alertService.exito(resp.message);
          this.mostrarFormulario = false;
          this.sePuedeActualizar = false;
          this.sePuedeEliminar = false;
          this.gestoresSeleccionados = [];
          this.listaGestores();
        }
      },
      error: (err) => {
        if (err.status === Constants_empresa.STATUS_CONFLICT) {
          this.alertService.error(err.error?.message);
        }
      }
    });
  }
  // Función que valida los gestores seleccionados en la tabla
  verificarSeleccion(gestor: DetalleGestorDTO[]){
    this.gestoresSeleccionados = [...gestor];
    if (gestor.length === Constants_empresa.UNO) {
      this.sePuedeActualizar = true;
      this.sePuedeEliminar = true;
      gestor.forEach(gestor => {
        this.gestorSeleccionado = gestor;
        this.idJuridica = gestor.idPersonaJuridica;
        this.idGestor = gestor.id;
      });
    } else if (gestor.length > Constants_empresa.UNO){
      this.sePuedeActualizar = false;
      this.sePuedeEliminar = true;
    }
  }
  // Función que filtra y ordena los usuarios
  filtrar(event: FiltroDto<object>){
    this.filtroGestores = event;
    console.log(this.filtroGestores)
    this.listaGestores(
      this.filtroGestores.selectedPage,
      this.filtroGestores.tamanoPagina,
      this.filtroGestores.filtros.tipoIdentificacion,
      this.filtroGestores.filtros.identificacion,
      this.filtroGestores.filtros.nombre,
      this.filtroGestores.ordenarPor,
      this.filtroGestores.ordenarAsc
        ? Constants_empresa.ASC
        : Constants_empresa.DESC
    );
  }
}
